import axios from "axios";

import { DispositionFormMaterial, EditDispositionParams } from "../../../types";
import { waitForBatchToBeFinished } from "../../../helpers/waitForBatchToBeFinished";

export const editDisposition = async ({
  materialGroups,
  scaleTicketDate,
  scaleTicketNumber,
  dispositionInvoiceDate,
  dispositionInvoiceNumber,
  ...params
}: EditDispositionParams) => {
  const resp = await axios
    .put("transactions/disposition", {
      ...params,
      scaleTicket: {
        ticketNumber: scaleTicketNumber,
        createdDate: scaleTicketDate,
      },
      invoice: {
        date: dispositionInvoiceDate,
        number: dispositionInvoiceNumber,
      },
      materials: materialGroups
        .reduce(
          (result, g) => [...result, ...g.items],
          [] as DispositionFormMaterial[]
        )
        .filter((m) => m.units.unitQuantity > 0),
    })
    .then((res) => res.data);

  await waitForBatchToBeFinished(params.transactionId, Date.now());

  return resp;
};

export default { editDisposition };
